import { Typography } from "@suraasa/placebo-ui"
import Paper from "features/AssignmentResult/Paper"
import { Lock } from "iconoir-react"

import styles from "./Submission.module.css"

const SubmissionPreview = ({ content = "" }) => {
  return (
    <>
      <Paper>
        <div
          className={styles.contentDivBlocked}
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      </Paper>
      <div className="absolute left-0 flex w-full flex-col items-center bg-white pb-1">
        <span className="mb-1 rounded-full bg-onSurface-200 p-1 shadow-md">
          <Lock />
        </span>
        <Typography variant="largeBody">
          To view the full submission, please login as school
        </Typography>
        {/* <a
          href={getPlatformURL(
            "sso",
            "/school/login" +
              `?redirect-url=${window.encodeURIComponent(
                getPlatformURL(
                  "hire",
                  window.location.pathname.replace("/profile/", "/teacher/")
                )
              )}`
          )}
        >
          <Button rounded className="mt-2">
            Sign in as School
          </Button>
        </a> */}
      </div>
    </>
  )
}

export default SubmissionPreview
